// English-only fallback storyboards. Supplied films are handled by video.js.
const films = [
  {
    "id": "H01",
    "title": "Workout done. Day on.",
    "duration": "12 seconds",
    "ratio": "16:9 main film; separate 9:16 composition",
    "priority": "P0",
    "voiceover": "No voiceover. Natural location sound; brand copy added in editing.",
    "shots": [
      [
        "0–2.5s",
        "An adult woman has finished an ordinary workout. Seated near the exit, she gathers her belongings and catches her breath. Training is already over."
      ],
      [
        "2.5–4.5s",
        "A medium side view follows her putting on a light shirt and picking up her bag. Keep the outfit and small orange accents consistent."
      ],
      [
        "4.5–6s",
        "Show the capped reference bottle beside the bag. An approved real-use insert may replace this shot; otherwise keep the still life and do not invent application instructions."
      ],
      [
        "6–9s",
        "Match the bag-lifting movement into a street scene. Preserve the person, clothing and bag. Do not imply that the product replaces washing."
      ],
      [
        "9–12s",
        "She greets a friend outside a cafe. Leave a clean ending for the brand line. The cafe is a proposed setting, not a required product-use context."
      ]
    ]
  },
  {
    "id": "U01",
    "title": "Next stop: coffee.",
    "duration": "15 seconds",
    "ratio": "9:16",
    "priority": "P0",
    "voiceover": "Record in post, without lip-sync: Workout done. Coffee next. A little moment in between. Mist. Move on.",
    "shots": [
      [
        "0–3s",
        "Phone-style footage after the workout: an adult creator puts on an outer layer. The camera moves toward a bag and bench. Record English narration separately."
      ],
      [
        "3–5s",
        "A natural close-up shows the creator taking a capped mistmove bottle from their own bag."
      ],
      [
        "5–7s",
        "Hold on the product, then cut to the bag. Only substitute an approved real-use insert; never imply that showering is unnecessary."
      ],
      [
        "7–11s",
        "Zip the bag and head outside. Use subtle handheld movement, not cinematic slow motion."
      ],
      [
        "11–15s",
        "At an outdoor cafe, set down the bag as a friend offers a cup. Avoid forced placement next to food or drink; end with an unposed smile."
      ]
    ]
  },
  {
    "id": "U02",
    "title": "Class out. Catch up.",
    "duration": "15 seconds",
    "ratio": "9:16",
    "priority": "P1",
    "voiceover": "Record in post, without lip-sync: Class is over. The catch-up starts now. Mist. Move on.",
    "shots": [
      [
        "0–3s",
        "Dance class has ended. An adult participant picks up a water bottle or outer layer and chats casually. This is not a professional stage performance."
      ],
      [
        "3–5s",
        "Put on an outer layer and pick up the reference mistmove bottle beside the bag."
      ],
      [
        "5–7s",
        "Pause on the capped bottle in hand. Replace with real application footage only after it has been reviewed and approved."
      ],
      [
        "7–10s",
        "Use a jacket or door-opening movement to transition outside, where a friend is waiting."
      ],
      [
        "10–15s",
        "The friends walk and talk naturally. Avoid exaggerated posing or thumbs-up gestures to camera. Leave room for the closing brand line."
      ]
    ]
  },
  {
    "id": "U03",
    "title": "Run over. Plans open.",
    "duration": "15 seconds",
    "ratio": "9:16",
    "priority": "P1",
    "voiceover": "Record in post, without lip-sync: Run over. No rush. The rest of the day is mine. Mist. Move on.",
    "shots": [
      [
        "0–3s",
        "The run is already over. Walking slows to a stop near a park exit; show ordinary running shoes and feet."
      ],
      [
        "3–5s",
        "Seated on a bench, loosen a bag strap and take out the bottle. Breathing is natural, without exaggerated exhaustion."
      ],
      [
        "5–7s",
        "Pause on the product. Insert a real application shot only after the usage details have been confirmed."
      ],
      [
        "7–11s",
        "Put on a light outer layer, pick up the bag and stand."
      ],
      [
        "11–15s",
        "Spend an unhurried moment reading outdoors or watching the trees. The next part of the day can be leisure, not a claim of improved productivity."
      ]
    ]
  },
  {
    "id": "P01",
    "title": "Meet your next-move mist.",
    "duration": "10 seconds",
    "ratio": "9:16 master; optional 4:5 web crop",
    "priority": "P0",
    "voiceover": "No voiceover. Natural contact sounds; brand copy added in editing.",
    "shots": [
      [
        "0–2s",
        "Show the approved reference bottle from the front on a warm-white background, with soft side lighting and legible packaging."
      ],
      [
        "2–4s",
        "A static close-up of the cap and nozzle. Do not press the pump or generate spray effects."
      ],
      [
        "4–6s",
        "A hand places the real-proportion bottle into an everyday bag. Do not claim universal bag fit or airline compliance."
      ],
      [
        "6–8s",
        "Rest the bottle beside the bag, with a small orange fabric accent."
      ],
      [
        "8–10s",
        "End on a clean product shot. The website offers one, two or three bottles of the same formula, not three different formulas."
      ]
    ]
  }
];
const dialog = document.querySelector('#brief-dialog');
let lastTrigger;
function openDialog(target, trigger) {
  if (!target) return;
  lastTrigger = trigger;
  target.showModal();
  document.body.style.overflow = 'hidden';
}
document.querySelectorAll('[data-film]').forEach(button => {
  button.addEventListener('click', () => {
    const film = films.find(item => item.id === button.dataset.film);
    if (!film || !dialog) return;
    document.querySelector('#dialog-kicker').textContent = film.id + ' / ' + film.duration;
    document.querySelector('#dialog-title').textContent = film.title;
    document.querySelector('#dialog-shots').replaceChildren(...film.shots.map(([time,text]) => {
      const item = document.createElement('li');
      const label = document.createElement('strong');
      label.textContent = time;
      item.append(label, document.createTextNode(text));
      return item;
    }));
    document.querySelector('#script-link').href = (window.MistmovePreview?.productionUrl || '/?view=mistmove-production') + '#' + film.id;
    openDialog(dialog, button);
  });
});
if (dialog) {
  dialog.querySelector('.close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    document.body.style.overflow = '';
    lastTrigger?.focus();
  });
}
const names = {1:'single',2:'duo',3:'trio'};
const counts = {1:'One bottle',2:'Two bottles',3:'Three bottles'};
document.querySelectorAll('[name=set]').forEach(radio => radio.addEventListener('change', () => {
  const image = document.querySelector('#product-image');
  image.src = window.MistmovePreview.assets[names[radio.value]];
  image.alt = 'Product illustration for ' + counts[radio.value].toLowerCase() + ' of the same mistmove product';
  document.querySelector('#set-caption').textContent = radio.value === '2' ? 'Two bottles. One for your bag, one in reserve.' : counts[radio.value] + '. Same mist.';
}));
